export function initializeToast(options = {}) {
  return (dispatch) => {
      dispatch({ payload: options, type: 'ADD_TOAST' });
  }
}
export function addToast(options = {}) {
  return (dispatch) => {
    setTimeout(() => { dispatch({ payload:"NA", type: 'REMOVE_TOAST' }); },2000)
    dispatch({  payload: options, type: 'ADD_TOAST'});
  }
}

export function removeToast(id) {
  return (dispatch) => {
    dispatch({ payload: id, type: 'REMOVE_TOAST' });
  }
}
